import React, { useEffect } from "react";
import './home.scss'
import { isMobile } from '@/utils'
import ContentPc from "./components/ContentPc";

import ContentH5 from "./components/ContentH5";

function Home(props) {
    const type = isMobile()
    useEffect(() => {

    }, [])
    return (
        <>
            <div className="home">
                {!type ? (<ContentPc/>) : (<ContentH5/>)}
            </div>
        </>
    )
}
export default Home